import { API_BASE_URL } from "../env";
import { apiFetch } from "./client";

export interface Workspace {
  id: string;
  slackTeamId: string;
  teamName: string;
  status: "active" | "legacy" | "revoked";
  createdAt: string;
  botUserId: string;
  installedByUserId: string;
}

export async function listWorkspaces(): Promise<Workspace[]> {
  const data = await apiFetch<{ workspaces: Workspace[] }>("/api/workspaces");
  return data.workspaces;
}

export async function disconnectWorkspace(id: string) {
  return apiFetch(`/api/workspaces/${id}`, { method: "DELETE" });
}

/**
 * The install is a top-level redirect (Slack OAuth), not an XHR — the
 * browser must navigate so Slack can bounce back through the API callback.
 */
export function slackInstallUrl(opts?: { returnPath?: string }): string {
  const base = `${API_BASE_URL}/api/slack/install`;
  if (!opts?.returnPath) return base;
  const q = new URLSearchParams({ return: opts.returnPath });
  return `${base}?${q.toString()}`;
}

export interface WorkspaceImpact {
  configs: number;
  reports: number;
}

export async function workspaceImpact(id: string): Promise<WorkspaceImpact> {
  return apiFetch<WorkspaceImpact>(`/api/workspaces/${id}/impact`);
}
